import { styled } from '@mui/material';

import Dialog, { dialogClasses } from '../../../components/Dialog';
import { forMobile } from '../../../utils/media-queries';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  [forMobile(theme)]: {
    [`& .${dialogClasses.paper}`]: {
      margin: theme.spacing(8, 4),
      width: '100%',
    },
  },
}));

export const Image = styled('img')(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[100]}`,
  borderRadius: 8,
  overflow: 'hidden',
}));
